import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { toTitleCase } from "../../../../pages/gene/components/ProteinAtlas/helpers";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import {
  getProteinAtlasData,
  getHPATopProteinExpression,
  getTissuesDetectedLength,
} from "../../../../state/selectors/ProteinAtlas.selectors";
import { cropNumber, DEFAULT_COLOR } from "../../../../common/helpers/helpers";
import { ProteinAtlasType } from "../../../componentTypes/ProteinAtlasType";

const GeneProteinAtlasCard = ({
  card,
  HPATopProteinExpression,
  tissuesDetected,
  proteinAtlasData,
}) => {
  const isDisabled = !Object.keys(proteinAtlasData || {}).length;
  const color = isDisabled
    ? DEFAULT_COLOR
    : getPathogenicityColorByAllNames("Pathogenic");
  const cancerNum = HPATopProteinExpression?.occurrences
    ? HPATopProteinExpression.occurrences - 1
    : null;
  const msg = cancerNum ? ` and ${cancerNum} more ` : "";
  return (
    <CardWrapper {...card} card={card} isDisabled={isDisabled} color={color}>
      {HPATopProteinExpression?.name ? (
        <div>
          <span>{"Top: "}</span>
          <span
            className="tw-font-bold"
            data-testid="top-condition"
          >{`${toTitleCase(HPATopProteinExpression.name)} ${msg} (${cropNumber(
            HPATopProteinExpression.value,
            2
          )}%)`}</span>
        </div>
      ) : null}
      {tissuesDetected ? (
        <div>
          Tissues: <b>{tissuesDetected}</b>
        </div>
      ) : null}
    </CardWrapper>
  );
};

GeneProteinAtlasCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  HPATopProteinExpression: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number,
    occurrences: PropTypes.number,
  }),
  tissuesDetected: PropTypes.number,
  proteinAtlasData: ProteinAtlasType,
};

GeneProteinAtlasCard.defaultProps = {
  HPATopProteinExpression: null,
  tissuesDetected: null,
  proteinAtlasData: {},
};

const mapStateToProps = (state) => ({
  HPATopProteinExpression: getHPATopProteinExpression(state),
  tissuesDetected: getTissuesDetectedLength(state),
  proteinAtlasData: getProteinAtlasData(state),
});

export default connect(mapStateToProps)(GeneProteinAtlasCard);
